import React, { ComponentType } from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { RootState } from '../store/modules/rootReducer'

export interface IRouteWrapperProps extends RouteProps {
  isPrivate?: boolean
  component: ComponentType
}

const RouteWrapper: React.FC<IRouteWrapperProps> = ({ isPrivate, component, ...rest }) => {
  const { signed } = useSelector((state: RootState) => state.auth)
  const { profile } = useSelector((state: RootState) => state.student)

  if ((!signed || !profile) && isPrivate) {
    return <Redirect to="/" />
  }

  if (signed && profile && !isPrivate) {
    return <Redirect to="/home" />
  }

  return <Route {...rest} component={component} />
}

export default RouteWrapper
